import { post,put,del,get } from './axios'

// 공지사항의 CRUD를 나열
export const insertFaq = async (params) => {
  const { status, data } = await post("/faq/insertFaqAjax", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const updateFaq = async (params) => {
  const { status, data } = await post("/faq/updateFaqAjax", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const updateFaqFiles = async (params) => {
  const { status, data } = await post("/faq/updateFaqFiles", params,true);

  if (status === 200 || status === 201) {
    return data;
  }
};


export const deleteFaq = async (params) => {
  const { status, data } = await del("/faq/deleteFaqAjax", params);

  if (status === 200 || status === 201) {
    return data;
  }
};

export const getFaqDetail = async (params) => {
  const { status, data } = await get("/faq/selectFaqDetailAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const faqList = async (params) => {
  const { status, data } = await get("/faq/selectFaqAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}
